var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapacitacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.1 93.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#3040e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.6,0C34.85,5.33,9.84,16.23,0,16.23v38.55c0,18.11,36.42,37.94,38.55,38.55,2.13-.56,38.55-21.81,38.55-36.52V16.23c-10.65,0-34.75-10.91-38.5-16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.49,65.43l-15.42-15.47,2.49-2.54,12.93,12.99,25.16-25.16,2.49,2.54-27.64,27.64Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitacion);
export default __webpack_public_path__ + "static/media/Capacitacion.cb94ae390d29bc061e0479cad2940c63.svg";
export { ForwardRef as ReactComponent };